module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306103.ac2a20e1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSat/FormatoSimplificado_306103.pdf
// module id = 332
// module chunks = 0